// extracted by mini-css-extract-plugin
export default {"FallbackErrorWrap":"FallbackError_FallbackErrorWrap__FDg8P","lottieWrap":"FallbackError_lottieWrap__nsmaL"};